export default function () {
  if (this.$route.params.email) {
    this.filters['user.email'] = this.$route.params.email
  }

  this.loadOrders()
}
